import { GenericDialog } from '@AMIEWEB/Alerts/GenericDialog';
import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { placementDetailsAction } from 'store/redux-store/placement-details/slice';
import { DocumentButtonType } from './DocumentsTab';

export const ConfirmationModal = ({
  placementId,
  confirmationModalDetails,
  onClose,
}: {
  placementId: string;
  confirmationModalDetails: any;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onConfirm = () => {
    if (confirmationModalDetails.type === DocumentButtonType.Create_Wage_Request) {
      dispatch(placementDetailsAction.createWageRequestForm({ placementId: placementId }));
    }
    onClose();
  };
  const getModalText = () => {
    switch (confirmationModalDetails.type) {
      case DocumentButtonType.Create_Wage_Request:
        return ({
          title: t('placement.wageRequestButton.confirmationModal.title'),
          body: t('placement.wageRequestButton.confirmationModal.body'),
          cancel: t('placement.wageRequestButton.confirmationModal.cancel'),
          confirm: t('placement.wageRequestButton.confirmationModal.confirm'),
        });
      default:
        return ({
          title: '', body:'',cancel: '', confirm: ''});
    }
  }
  return (
    <GenericDialog
      open={confirmationModalDetails.open}
      dialogTitleProps={{
        text: getModalText().title,
      }}
      fullWidth
      maxWidth={'sm'}
      disableEscapeKeyDown
      dialogActions={[
        {
          onClick: onClose,
          text: getModalText().cancel,
          color: 'info',
        },
        {
          onClick: onConfirm,
          text: getModalText().confirm,
          variant: 'contained',
        },
      ]}
    >
      <Typography>{getModalText().body}</Typography>
    </GenericDialog>
  );
};
